export function Badge({ variant = "default", children, testId }) {
  const map = {
    default: "bg-gray-50 text-gray-700 border-gray-200",
    success: "bg-emerald-50 text-emerald-700 border-emerald-200",
    pending: "bg-amber-50 text-amber-700 border-amber-200",
    danger: "bg-red-50 text-red-700 border-red-200",
    info: "bg-blue-50 text-blue-700 border-blue-200",
    neutral: "bg-slate-100 text-slate-600 border-slate-200",
  };
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center text-[11px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-sm border ${map[variant] || map.default}`}
    >
      {children}
    </span>
  );
}

export const statusVariant = (s) => {
  const v = String(s || "").toLowerCase();
  if (["approved", "active", "paid", "won", "completed"].includes(v)) return "success";
  if (["pending"].includes(v)) return "pending";
  if (["auto_rejected", "auto-rejected"].includes(v)) return "neutral";
  if (["rejected", "inactive", "lost", "failed"].includes(v)) return "danger";
  return "default";
};

// Pretty label for status badges. Keeps single-word default but hyphenates
// auto_rejected so the badge reads "AUTO-REJECTED" instead of "AUTO_REJECTED".
export const statusLabel = (s) => {
  const v = String(s || "");
  if (v.toLowerCase() === "auto_rejected") return "Auto-rejected";
  return v;
};
